import script from "./search.vue?vue&type=script&setup=true&lang=ts"
export * from "./search.vue?vue&type=script&setup=true&lang=ts"

import "./search.vue?vue&type=style&index=0&id=1ebcd9fb&lang=scss&scoped=true"

import exportComponent from "/home/circleci/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ebcd9fb"]])

export default __exports__